import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { Outlet, Link as RouterLink } from "react-router-dom";

import palette from "theme/palette";

import Logo from "../components/shared/Logo";

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: "100%",
  position: "absolute",
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up("sm")]: { padding: theme.spacing(5, 5, 0) },
}));

export default function LogoOnlyLayout(): JSX.Element {
  return (
    <Box sx={{ backgroundColor: palette.light.secondary.lighter, height: "100%" }}>
      <HeaderStyle>
        <RouterLink to="/">
          <Logo
            imgHeight={72}
            imgWidth={72}
          />
        </RouterLink>
      </HeaderStyle>
      <Outlet />
    </Box>
  );
}
